import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { Input, InputAdornment } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import theme from "../../../../assets/theme";
import KZTypeSelector from "../../../../components/selectors/KZTypeSelector";
import i18nStore from "../../../../i18n/store";
import { NodeInterface } from "../../../tables/schemas/nodes";
import filtersStore from "./filtersStore";
import filterStore from "./filtersStore";


interface CalcResultFiltersProps {
    nodes: NodeInterface[];
}

const CalcResultFilters = observer((props: CalcResultFiltersProps) => {
    const translations = i18nStore.getTranslations;
    const params = useParams();
    const projectId: number = +(params.projectId || 0);


    useEffect(() => {
        if (props.nodes && props.nodes.length > 0 && (filterStore.getProjectId !== projectId || filterStore.getSelectedNode === null)) {
            filterStore.setSelectedNode(props.nodes[0].id);
        }
    }, [props.nodes]);

    const handleSelectNodeClick = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        index: number,
    ) => {
        const oldNode: number | null = filterStore.getSelectedNode;
        filterStore.setSelectedNode(index);
        filtersStore.setProjectId(projectId);
        if (oldNode !== index) {
            // TODO: сделать запрос за расчетными таблицами?
        }
    };
    let nodes = props.nodes;
    if (filterStore.getLocationOfDamageFilterString) {
        nodes = props.nodes.filter(
            (node: NodeInterface) => node.name.toLowerCase().includes(filterStore.getLocationOfDamageFilterString)
        );
    }


    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            pr: 1
        }}>
            <KZTypeSelector
                kzType={filterStore.getScType}
                setKzType={(val) => filterStore.setScType(val)}
            />
            <Box sx={{mt: 2}}>
                <Typography variant="h6" fontWeight={600} fontSize="1rem" textAlign="center">
                    {translations.damageLocation}
                </Typography>

                <Input
                    value={filterStore.getLocationOfDamageFilterString}
                    onChange={(e) => filterStore.setLocationOfDamageFilterString(e.target.value || "")}
                    sx={{ml: 1, flex: 1, fontSize: "0.85rem"}}
                    size="small"
                    placeholder={translations.filter}
                    startAdornment={
                        <InputAdornment position="start">
                            <SearchIcon/>
                        </InputAdornment>
                    }
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton size="small" onClick={() => filterStore.setLocationOfDamageFilterString("")}>
                                <ClearIcon fontSize="inherit"/>
                            </IconButton>
                        </InputAdornment>
                    }
                />

                <List
                    component="nav"
                    sx={{
                        height: 650,
                        overflowY: "auto",
                        "& .Mui-selected": {
                            color: "white !important",
                            background: `${theme.palette.primary.main} !important`,
                        },
                    }}
                >
                    {
                        nodes.length > 0 && nodes.map((node: NodeInterface) => (
                            <ListItemButton
                                key={node.id}
                                sx={{py: 0}}
                                selected={filterStore.getSelectedNode === node.id}
                                onClick={(event) => handleSelectNodeClick(event, node.id)}
                            >
                                <ListItemText primary={node.name || "-"}/>
                            </ListItemButton>
                        ))
                    }
                </List>
            </Box>
        </Box>
    );
});


export default CalcResultFilters;
